import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _adjustCreditRequest = {
    creditAmount: 'DOUBLE',
    targetDate: 'google.protobuf.Timestamp',
};
var _adjustCreditResponse = {};
var _balance = { orderInfo: '_memberOrderInfo', benefit: '_memberBenefit' };
var _cancelRedemptionRequest = {};
var _cancelRedemptionResponse = {};
var _getBalanceRequest = { targetDate: 'google.protobuf.Timestamp' };
var _getBalanceResponse = { balanceItems: '_balance' };
var _getEligibleOrdersRequest = {
    targetDate: 'google.protobuf.Timestamp',
    requiredCredits: 'DOUBLE',
};
var _getEligibleOrdersResponse = {
    memberOrdersByPlan: '_memberOrdersByPlan',
    memberFutureOrdersByPlan: '_memberOrdersByPlan',
};
var _listTransactionsRequest = {};
var _listTransactionsResponse = { transactions: '_transaction' };
var _memberBenefit = {
    totalCredits: 'google.protobuf.DoubleValue',
    remainingCredits: 'google.protobuf.DoubleValue',
};
var _memberOrder = {
    validFrom: 'google.protobuf.Timestamp',
    validUntil: 'google.protobuf.Timestamp',
    memberBenefits: '_memberBenefit',
};
var _memberOrderInfo = {
    validFrom: 'google.protobuf.Timestamp',
    validUntil: 'google.protobuf.Timestamp',
};
var _memberOrdersByPlan = { memberOrders: '_memberOrder' };
var _redeemRequest = {
    creditAmount: 'DOUBLE',
    targetDate: 'google.protobuf.Timestamp',
};
var _redeemResponse = {};
var _transaction = {
    amount: 'DOUBLE',
    creationDate: 'google.protobuf.Timestamp',
};
function resolveComWixPricingplansBenefitsApiV2MemberBenefitsUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/entitlements-proxy-member',
                destPath: '',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/pricing-plan-benefits/v2/member-benefits',
                destPath: '/v2/member-benefits',
            },
        ],
        '*.wixapps.net': [
            {
                srcPath: '/_api/pricing-plan-benefits/v2/member-benefits',
                destPath: '/v2/member-benefits',
            },
        ],
        _: [
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/member-benefits',
                destPath: '/v2/member-benefits',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/member-benefits',
                destPath: '/v2/member-benefits',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/pricing-plan-benefits/v2/member-benefits',
                destPath: '/v2/member-benefits',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/member-benefits',
                destPath: '/v2/member-benefits',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/member-benefits',
                destPath: '/v2/member-benefits',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/member-benefits',
                destPath: '/v2/member-benefits',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/pricing-plan-benefits/v2/member-benefits',
                destPath: '/v2/member-benefits',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/pricing-plan-benefits/v2/member-benefits',
                destPath: '/v2/member-benefits',
            },
        ],
        'vod-server._base_domain_': [
            {
                srcPath: '/_api/pricing-plan-benefits/v2/member-benefits',
                destPath: '/v2/member-benefits',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/member-benefits',
                destPath: '/v2/member-benefits',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/member-benefits',
                destPath: '/v2/member-benefits',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/member-benefits',
                destPath: '/v2/member-benefits',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/member-benefits',
                destPath: '/v2/member-benefits',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/member-benefits',
                destPath: '/v2/member-benefits',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/member-benefits',
                destPath: '/v2/member-benefits',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/member-benefits',
                destPath: '/v2/member-benefits',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Gets benefits for use with a specific resource on a specific date for the current site member */
export function getEligibleOrders(payload) {
    var _a = serializer(_getEligibleOrdersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getEligibleOrdersResponse, {
        _memberBenefit: _memberBenefit,
        _memberOrder: _memberOrder,
        _memberOrdersByPlan: _memberOrdersByPlan,
    }).fromJSON;
    function __getEligibleOrders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.member_benefit',
            method: 'GET',
            methodFqn: 'com.wix.pricingplans.benefits.api.v2.MemberBenefits.GetEligibleOrders',
            url: resolveComWixPricingplansBenefitsApiV2MemberBenefitsUrl({
                protoPath: '/v2/member-benefits/eligible-orders',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getEligibleOrders.fromReq = fromReq;
    __getEligibleOrders.__isAmbassador = true;
    return __getEligibleOrders;
}
/** Redeems plan credits for the current site member */
export function redeem(payload) {
    var _a = serializer(_redeemRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_redeemResponse, {}).fromJSON;
    function __redeem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.member_benefit',
            method: 'POST',
            methodFqn: 'com.wix.pricingplans.benefits.api.v2.MemberBenefits.Redeem',
            url: resolveComWixPricingplansBenefitsApiV2MemberBenefitsUrl({
                protoPath: '/v2/member-benefits/redeem',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __redeem.fromReq = fromReq;
    __redeem.__isAmbassador = true;
    return __redeem;
}
/** Cancels a credit redemption for the current site member */
export function cancelRedemption(payload) {
    var _a = serializer(_cancelRedemptionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelRedemptionResponse, {}).fromJSON;
    function __cancelRedemption(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.member_benefit',
            method: 'POST',
            methodFqn: 'com.wix.pricingplans.benefits.api.v2.MemberBenefits.CancelRedemption',
            url: resolveComWixPricingplansBenefitsApiV2MemberBenefitsUrl({
                protoPath: '/v2/member-benefits/cancel-redemption',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cancelRedemption.fromReq = fromReq;
    __cancelRedemption.__isAmbassador = true;
    return __cancelRedemption;
}
/** Gets the balance for the specified member benefit */
export function getBalance(payload) {
    var _a = serializer(_getBalanceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getBalanceResponse, {
        _balance: _balance,
        _memberBenefit: _memberBenefit,
        _memberOrderInfo: _memberOrderInfo,
    }).fromJSON;
    function __getBalance(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.member_benefit',
            method: 'GET',
            methodFqn: 'com.wix.pricingplans.benefits.api.v2.MemberBenefits.GetBalance',
            url: resolveComWixPricingplansBenefitsApiV2MemberBenefitsUrl({
                protoPath: '/v2/member-benefits/balance',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixPricingplansBenefitsApiV2MemberBenefitsUrl({
                        protoPath: '/v2/member-benefits/balance',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getBalance.fromReq = fromReq;
    __getBalance.__isAmbassador = true;
    return __getBalance;
}
/** Gets credit transactions by filters */
export function listTransactions(payload) {
    var _a = serializer(_listTransactionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listTransactionsResponse, {
        _transaction: _transaction,
    }).fromJSON;
    function __listTransactions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.member_benefit',
            method: 'GET',
            methodFqn: 'com.wix.pricingplans.benefits.api.v2.MemberBenefits.ListTransactions',
            url: resolveComWixPricingplansBenefitsApiV2MemberBenefitsUrl({
                protoPath: '/v2/member-benefits/transactions',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listTransactions.fromReq = fromReq;
    __listTransactions.__isAmbassador = true;
    return __listTransactions;
}
/** create manual transaction - add or subtract credits */
export function adjustCredit(payload) {
    var _a = serializer(_adjustCreditRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_adjustCreditResponse, {}).fromJSON;
    function __adjustCredit(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.member_benefit',
            method: 'POST',
            methodFqn: 'com.wix.pricingplans.benefits.api.v2.MemberBenefits.AdjustCredit',
            url: resolveComWixPricingplansBenefitsApiV2MemberBenefitsUrl({
                protoPath: '/v2/member-benefits/contacts/{contactId}/adjustCredit',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __adjustCredit.fromReq = fromReq;
    __adjustCredit.__isAmbassador = true;
    return __adjustCredit;
}
//# sourceMappingURL=http.impl.js.map